module.exports = __webpack_public_path__ + "img/school_2.64e55d0.jpg";